import * as React from "react";
import { forwardRef } from "react";
const SvgPriorityNormal = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 8, height: 8, "data-name": "icon/priority/high", viewBox: "0 0 8 8", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M15 10v5.333h1.4V10zm0 6.667V18h1.4v-1.333z", transform: "translate(-13.001 -10)", fill: "#fff" }), /* @__PURE__ */ React.createElement("path", { d: "M15 10v5.333h1.4V10zm0 6.667V18h1.4v-1.333z", "data-name": "icon-priority", transform: "translate(-10.251 -10)", fill: "#fff" }));
const ForwardRef = forwardRef(SvgPriorityNormal);
export { ForwardRef as ReactComponent };
